<template>
	<div class="">
		<el-table
		  :data="tableData"
		  style="width: 100%"
		>
			<el-table-column
			  prop="machineNum"
			  label="设备编号"
			>
			</el-table-column>
			<el-table-column
			  prop="machineDate"
			  label="开门时间"
			>
			</el-table-column>
			<el-table-column
			  prop="machineIp"
			  label="设备IP"
			>
			</el-table-column>
		</el-table>

		<el-pagination
		  @size-change="handleSizeChange"
		  @current-change="handleCurrentChange"
		  layout="total, sizes, prev, pager, next, jumper"
		  :page-sizes="[1, 10, 20, 50, 100]"
		  :current-page="current"
		  :page-size="size"
		  :total="total">
		</el-pagination>
	</div>
</template>

<script>
export default {
	name: "DeviceDoorRecordTable",
	props: {
		deviceId: {
			validator: null // 禁用类型检查
		}
	},
	data() {
		return {

			// table 表格
			total: 0,
			size: 10,
			current: 1,

			tableData: []

		}
	},
	mounted() {
		this.getCabinetRecordList();
	},
	watch: {
		deviceId(newValue, oldValue) {
			console.log(newValue, oldValue);
			this.getCabinetRecordList();
		}
	},
	methods: {
		getCabinetRecordList() {
			this.$axios.get("/cabinet/recordList", {
				params: {
					machineId: this.deviceId,
					beginDate: '2024-01-01',
					endDate: '2024-03-15',
					// locationId: this.treeSelectLocationId,
					current: this.current,
					size: this.size
				}
			}).then(res => {
				const {records, total} = res.data.data;
				this.tableData = records;
				this.total = total;
				console.log(res);
				// this.tableData = res.data.data.records
				// this.size = res.data.data.size
				// this.current = res.data.data.current
				// this.total = res.data.data.total
			})
		},

		handleSizeChange(val) {
			console.log(`每页 ${val} 条`);
			this.size = val
			this.getCabinetRecordList();
		},

		handleCurrentChange(val) {
			console.log(`当前页: ${val}`);
			this.current = val
			this.getCabinetRecordList();
		},
	}
}
</script>

<style scoped>

</style>